import { useSubscription } from '@apollo/client';
import { gql } from '../graphql/generated';
import type { Post } from '../graphql/generated/graphql';
import { AddRemoveAction } from '../graphql/generated/graphql';
import useIsPublicView from '../utils/useIsPublicView';

const POST_TOPIC_ID_SET_SUBSCRIPTION = gql(/** @complexity 4 */ `
  subscription postTopicIdSet($postId: ID!) {
    postTopicSet(postId: $postId) {
      topicId
      action
    }
  }
`);

const usePostTopicIdSetSubscription = (postId: string) => {
  const isPublicView = useIsPublicView();

  useSubscription(POST_TOPIC_ID_SET_SUBSCRIPTION, {
    skip: !postId || isPublicView,
    variables: { postId },
    onData: ({ data: { data }, client }) => {
      const postTopicIdSet = data?.postTopicSet;
      if (!postTopicIdSet) return;

      client.cache.modify<Post>({
        id: client.cache.identify({ id: postId, __typename: 'Post' }),
        fields: {
          topics: (existingRefs, { toReference, readField }) => {
            if (postTopicIdSet.action === AddRemoveAction.Add) {
              return [
                ...existingRefs,
                toReference({
                  __typename: 'Topic',
                  id: postTopicIdSet.topicId,
                }),
              ];
            }
            return existingRefs.filter(
              (ref) => readField('id', ref) !== postTopicIdSet.topicId,
            );
          },
        },
      });
    },
  });
};

export default usePostTopicIdSetSubscription;
